export default {
  slidingScaleFee(state) {
    const orderDetails = state.orderDetails
    
    if (orderDetails)
      return orderDetails
        .map(orderDetail => +orderDetail.slidingScaleFee)
        .reduce((a, b) => a + b, 0);

    return 0
  },

  shippingDate(state) {
    return state.shippingDate ? state.shippingDate.toISOString().split('T')[0] : ''
  }
}
